export const isSystemAction = (actionId: string) => !actionId.match(/^action/)
